var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacyBox",domProps:{"innerHTML":_vm._s(
    _vm.convertToHTML(
      _vm.getLocalizedContent(_vm.privacy.attributes, 'Datenschutzerklaerung')
    )
  )}})
}
var staticRenderFns = []

export { render, staticRenderFns }